import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { MarginRuleRoute, MarginRulePathName } from '@/modules/ta/marginrule/marginrule.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${MarginRuleRoute.MARGINRULES}`,
      name: MarginRulePathName.MARGINRULES,
      component: () =>
        import(/* webpackChunkName: "marginrules-page" */ './pages/MarginRulesPage.vue'),
    },
    {
      path: `/${MarginRuleRoute.MARGINRULES}/new`,
      name: MarginRulePathName.MARGINRULEFORM_NEW,
      component: () =>
        import(/* webpackChunkName: "marginrule-form-page" */ './pages/MarginRuleFormPage.vue'),
      props: true,
    },
    {
      path: `/${MarginRuleRoute.MARGINRULES}/:id`,
      name: MarginRulePathName.MARGINRULEFORM,
      component: () =>
        import(/* webpackChunkName: "marginrule-form-page" */ './pages/MarginRuleFormPage.vue'),
      props: true,
    },
  ],
  Module.MARGINRULE
);
